/* React */
import { useState } from 'react'

/* Material */
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import useStyles from '../styles'

interface QuantityProps {
  productId: number
  Quantity: number
  handleChangeQuantity: (Quantity: number) => void
  onlyStock?: true
  stock?: number
  idPrefix?: string
}

const QuantitySelector: React.FC<QuantityProps> = ({
  productId, Quantity, handleChangeQuantity,
  onlyStock, stock, idPrefix = '',
}) => {
  const classes = useStyles()

  const [textInput, setTextInput] = useState<boolean>(false)
  const toggleTextInput = () => {
    setTextInput(prev => !prev)
  }

  const size = onlyStock ? (stock||0) : 10

  return <div>

    {!textInput
    
    ? <TextField
        id={`${idPrefix}quantity-select-${productId}`}
        className={classes.formControl}
        select variant='standard'
        label="Menge"
        value={Quantity}

        //SelectProps={{ native: true }}

        onChange={({target:{value}}) => {
          const Quantity = typeof value === 'number' ? value : 1
          if (Quantity > 9) toggleTextInput()
          handleChangeQuantity(Quantity)
        }}
      >

        {Array.from(Array(Math.min(size+1,10)).keys()).slice(1).map(i=>
          <MenuItem key={i} value={i}>
            {i}
          </MenuItem>
        )}

        {size >= 10 &&
          <MenuItem value={10}>
            10 +
          </MenuItem>
        }

      </TextField>

    : <TextField
        id={`${idPrefix}quantity-input-${productId}`}
        variant='standard'
        value={Quantity}
        onChange={({target:{value}}) => {
          const max = onlyStock ? (stock||0) : 500
          let Quantity = Number(value)
          if (Quantity < 1) Quantity = 1
          if (Quantity > max) Quantity = max
          
          handleChangeQuantity(Quantity)
        }}
        autoFocus
        /*onFocus={event=>event.target.select()}*/
      />

    }

  </div>
  
}

export default QuantitySelector
